

document.addEventListener("DOMContentLoaded", yall);

url = window.location.href.split("/");

console.log(url);


$("#openMenu").click(function(){    
    $("#menu").addClass('open');
    $('body').css('overflow-y','hidden');

});
$("#closeMenu").click(function(){
    $("#menu").removeClass('open');
    $('body').css('overflow-y','scroll');
});

$(".anchor-links .nav-links a").click(function(){
    var link  = $(this).attr('href');
    document.querySelector(link).scrollIntoView({ behavior: 'smooth' });

    $("#menu").removeClass('open');
    $('.wrapper').css('overflow-y','scroll');
});


function lineNav(){
    
    var darkline = $(".dark-line");
    var dlheight = darkline.height();
    
    var line = $(".dark-line").offset().top + dlheight;

    var i = $("#intro").offset().top;
    var d = $("#design").offset().top;
    var m = $("#materials").offset().top;
    var lp = $("#local-production").offset().top;
    var ep = $("#ethical-production").offset().top;
//     var fq = $("#faq").offset().top;


    // console.log(line + " " + i);

    if(line >= fq)
    {
        $(".dark-line").css("top",dlheight * 6);
    }
    else if(line >= ep)
    {
        $(".dark-line").css("top",dlheight * 4);
    }
    else if(line >= lp)
    {
        $(".dark-line").css("top",dlheight * 3);
    }
    else if(line >= m)
    {
        $(".dark-line").css("top",dlheight * 2);
    }
    else if(line >= d)
    {
        $(".dark-line").css("top",dlheight * 1);
    }
    else 
    {
        $(".dark-line").css("top",0);
    }
    
}

// lineNav();


// $(".openTc").click(function(){
//     $("#tcPopup").addClass('open');
//     $('.wrapper').css('overflow-y','hidden');
//     $('.wrapper').addClass('blur');

// });
// $("#closeTc").click(function(){
//     $("#tcPopup").removeClass('open');
//     $('.wrapper').css('overflow-y','scroll');
//     $('.wrapper').removeClass('blur');


// });
// $(".openCookies").click(function(){
//     $("#cookiePopup").addClass('open');
//     $('.wrapper').css('overflow-y','hidden');
//     $('.wrapper').addClass('blur');

// });
// $("#closeCookie").click(function(){
//     $("#cookiePopup").removeClass('open');
//     $('.wrapper').css('overflow-y','scroll');
//     $('.wrapper').removeClass('blur');


// });
// $(".openPrivacy").click(function(){
//     $("#privacyPopup").addClass('open');
//     $('.wrapper').css('overflow-y','hidden');
//     $('.wrapper').addClass('blur');

// });
// $("#closePrivacy").click(function(){
//     $('.wrapper').css('overflow-y','scroll');
//     $("#privacyPopup").removeClass('open');
//     $('.wrapper').removeClass('blur');

// });
// $(".openNs").click(function(){
//     $("#nsPopup").addClass('open');
//     $('body').css('overflow-y','hidden');
//     // $('.wrapper').addClass('blur');
    
// });
// $(".openCTA").click(function(){
//     $("#ksPopup").addClass('open');
//     $('body').css('overflow-y','hidden');
//     $('.wrapper').addClass('blur');
//     makeTimer(); 
// });
// $("#closeCd").click(function(){
//     $("#cdPopup").removeClass('open');
//     $('body').css('overflow-y','scroll');
//     $('.wrapper').removeClass('blur');
// });
$("#closeCk").click(function(){
    $("#ckPopup").addClass('close');
    // $('body').css('overflow-y','scroll');

});
// $("#closeKs").click(function(){
//     $("#ksPopup").removeClass('open');
//     $('body').css('overflow-y','scroll');
//     $('.wrapper').removeClass('blur');

// });
// $(".ks-btn").click(function(){
//     $("#ckPopup").addClass('close');
//     $("#cdPopup").removeClass('open');
//     $("#ksPopup").removeClass('open');
//     $('.wrapper').removeClass('blur');

//     $('body').css('overflow-y','scroll');

//     document.querySelector('#kick-starter').scrollIntoView({ behavior: 'smooth' });
// });

$(".site-nav__button").click(function(){
  $(this).siblings('div').toggleClass('display');
}); 

$(".closeNs").click(function(){
    $("#cdPopup").removeClass('open');
    $("#nsPopup").removeClass('open');
    // console.log($('#Contact_-name').val());
    $('input[type=text]').val('');
    $('input[type=text]').removeClass('active');
    $('#ns-next').addClass('disabled');
    $('#ns-next').prop('disabled',true);
    $('input[type=email]').val('');
    $('input[type=email]').removeClass('active');

    $('#ns-submit').addClass('disabled');
    $('#ns-submit').prop('disabled',true);
    $('body').css('overflow-y','scroll');
    $('.wrapper').removeClass('blur');

    $('.response-div').hide();
    $('.mail-div').hide();
    $('.name-div').show();
});

$('input[type=text]').keyup(function(){
    // console.log("hi");
    if($(this).val().length > 0){
        $('.ns-error').text("");
        $('.ns-es-error').text("");
        $('input[type=text]').removeClass('error');
        $('input[type=text]').addClass('active');
        $('#ns-next').removeClass('disabled');
        $('#ns-next').prop('disabled',false);

    }
    else{
        $('input[type=text]').removeClass('error');
        $('input[type=text]').removeClass('active');
        $('#ns-next').addClass('disabled');
        $('#ns-next').prop('disabled',true);

    }
});
$('#ns-next').click(function(){
    // console.log("hi");
    if($('input[type=text]').val().length <= 2){
        $('.ns-error').text("Please enter correct name");
        $('.ns-es-error').text("Por favor escribe el nombre correctamente");
        $('input[type=text]').addClass('error');
    }
    else{
        $('.ns-error').text("");
        $('input[type=text]').removeClass('error');
        $('.name-div').hide();
        $('.mail-div').show();

    }
});
var $contact_form = $('.contact-form');
$contact_form.submit(function(e){
   e.preventDefault();
    var email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if($(this).val().length > 0){
        $('.ns-error').text("");
        $('.ns-es-error').text("");
        $('input[type=text]').removeClass('error');
        $('input[type=text]').addClass('active');
//         $('#ns-next').removeClass('disabled');
        $('#ns-next').prop('disabled',false);

    }
  else{
      $('.ns-error').text("");
        $('input[type=text]').removeClass('error');
        $('.name-div').hide();
        $('.mail-div').show();

  
  if(email.test($("input[type=email]").val())) {
        
        $('input[type=email]').removeClass('error');
        $('.sb-error').text("");
        $('.sb-es-error').text("");
                $.ajax({
                  type: "POST",
                  url: '/contact#contact_form',
                  data: $('.contact-form').serialize(),
                  success: function (data) {
                    $('.mail-div').hide();
                    $('.response-div').show();
                     $("#nsPopup").addClass('open');
   					 $('body').css('overflow-y','hidden');
                    e.preventDefault();

                  },
                  error: function(data) {
                    $('.sb-error').text("It looks like you’re already registered! Awesome :) ");
                    $('.sb-es-error').text("Parece que tu correo ya está registrado, qué bien! :)");
                        
                }
                });
               
        }
            else{
        $('.sb-error').text("It looks like something’s been misspelled, have a look! ");
        $('.sb-es-error').text("Parace que hay algo mal escrito, échale un ojo y repetimos");
        $('input[type=email]').addClass('error');
    }
   
  }});

    

$('input[type=email]').keyup(function(){
    // console.log("hi");
    if($(this).val().length > 0){
        $('.sb-error').text("");
        $('input[type=email]').removeClass('error');
        $('input[type=email]').addClass('active');
        $('#ns-submit').removeClass('disabled');
        $('#ns-submit').prop('disabled',false);
    }
    else{
        $('input[type=email]').removeClass('error');
        $('input[type=email]').removeClass('active');
        $('#ns-submit').addClass('disabled');
        $('#ns-submit').prop('disabled',true);
    }
});

function makeTimer() {

	//		var endTime = new Date("29 April 2018 9:56:00 GMT+01:00");	
		var endTime = new Date("9 September 2020 09:00:00 GMT+01:00");			
			endTime = (Date.parse(endTime) / 1000);

			var now = new Date();
			now = (Date.parse(now) / 1000);

			var timeLeft = endTime - now;

			var days = Math.floor(timeLeft / 86400); 
			var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
			var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
			var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));
  
			if (hours < "10") { hours = "0" + hours; }
			if (minutes < "10") { minutes = "0" + minutes; }
			if (seconds < "10") { seconds = "0" + seconds; }

			$("#days").html(days + "<span>Days</span>");
			$("#hours").html(hours + "<span>Hours</span>");
			$("#minutes").html(minutes + "<span>Minutes</span>");
			$("#seconds").html(seconds + "<span>Seconds</span>");		

    }
    setInterval(function() { makeTimer(); }, 100);

    
function setWheeler(){
    var h = $("#intro").offset().top;
    var wheelerHeight = $(".fixed-svg").height();
    
    var position = h + (wheelerHeight/2);

    // console.log(h + " " + wheelerHeight + " " + position);
    $(".fixed-svg").css("top",position+"px");
}   

function changeMenuIconColor(){
  if(url.length > 3 && (url[3]==="" || url[3]==="es")){
  
    var b = $(document).scrollTop();
    var menu = $("#openMenu").offset().top;
    var h = $("#home").offset().top;
    var i = $("#intro").offset().top;
    var d = $("#design").offset().top;
    var m = $("#materials").offset().top;
    var lp = $("#local-production").offset().top;
    var ep = $("#ethical-production").offset().top;
//     var fq = $("#faq").offset().top;
    var sp = $("#spring").offset().top;
    var sm = $("#summer").offset().top;
    var at = $("#autumn").offset().top;
    var wt = $("#winter").offset().top;
    var ns = $("#ns").offset().top;
    var height = menu - b;
    var menuPos = menu + height + 14;

    // console.log(menuPos + " " + i);
    if(menuPos < i)
    {
        $("#openMenu").css({
            "background": "#E9F1FA",
            "box-shadow": "6px 6px 16px #BECDE2, -6px -6px 16px rgba(255, 255, 255, 0.5)"
        });
        $("#icon-light").addClass("hide");
        $("#icon").removeClass("hide");
    }
    else if(menuPos >= i && menuPos < i + 50)
    {
        $("#openMenu").css({
            "background": "transparent",
        });
        $("#icon-light").addClass("hide");
        $("#icon").removeClass("hide");
    }
    else if(menuPos < sp)
    {
        $("#openMenu").css({
            "background": "#FBFBFB",
            "box-shadow": "6px 6px 16px #BECDE2, -6px -6px 16px rgba(255, 255, 255, 0.5)"

        });

        $("#icon-light").addClass("hide");
        $("#icon").removeClass("hide");

    }
    else if(menuPos >= sp && menuPos <= sp + 50)
    {
        $("#openMenu").css({
            "background": "transparent",
            "box-shadow": "6px 6px 16px #FFCD72, -6px -6px 16px rgba(255, 255, 255, 0.5)"
        });
        $("#icon").addClass("hide");
        $("#icon-light").removeClass("hide");

    }
    else if(menuPos < d)
    {
        $("#openMenu").css({
            "background": "#FFDEA2",
            "box-shadow": "6px 6px 16px #FFCD72, -6px -6px 16px rgba(255, 255, 255, 0.3)"
        });
        $("#icon").addClass("hide");
        $("#icon-light").removeClass("hide");

    }
    else if(menuPos >= d && menuPos <= d + 50)
    {
        $("#openMenu").css({
            "background": "transparent",
            "box-shadow": "6px 6px 16px #BECDE2, -6px -6px 16px rgba(255, 255, 255, 0.5)"
        });
        $("#icon-light").addClass("hide");
        $("#icon").removeClass("hide");

    }
    else if(menuPos < sm)
    {
        $("#openMenu").css({
            "background": "#FBFBFB",
            "box-shadow": "6px 6px 16px #BECDE2, -6px -6px 16px rgba(255, 255, 255, 0.5)"
            
        });
        $("#icon-light").addClass("hide");
        $("#icon").removeClass("hide");

    }
    else if(menuPos >= sm && menuPos <= sm + 50)
    {
        $("#openMenu").css({
            "background": "transparent",
            "box-shadow": " 6px 6px 16px #005c5c, -6px -6px 16px rgba(255,255,255,0.1)"
        });
        $("#icon").addClass("hide");
        $("#icon-light").removeClass("hide");

    }
    else if(menuPos < m)
    {
        $("#openMenu").css({
            "background": "#008181",
            "box-shadow": " 6px 6px 16px #005c5c, -6px -6px 16px rgba(255,255,255,0.1)"
        });
        $("#icon").addClass("hide");
        $("#icon-light").removeClass("hide");

    }
    else if(menuPos >= m && menuPos <= m + 50)
    {
        $("#openMenu").css({
            "background": "transparent",
            "box-shadow": "6px 6px 16px #BECDE2, -6px -6px 16px rgba(255, 255, 255, 0.5)"
        });
        $("#icon-light").addClass("hide");
        $("#icon").removeClass("hide");

    }
    else if(menuPos < at)
    {
        $("#openMenu").css({
            "background": "#FBFBFB",
            "box-shadow": "6px 6px 16px #BECDE2, -6px -6px 16px rgba(255, 255, 255, 0.5)"
            
        });
        $("#icon-light").addClass("hide");
        $("#icon").removeClass("hide");
    }
    else if(menuPos >= at && menuPos <= at + 50)
    {
        $("#openMenu").css({
            "background": "transparent",
            "box-shadow": "6px 6px 16px #c7a5a1, -6px -6px 16px rgba(255,255,255,0.2)"
        });
        $("#icon").addClass("hide");
        $("#icon-light").removeClass("hide");

    }
    else if(menuPos < lp)
    {
        $("#openMenu").css({
            "background": "#e5b3af",
            "box-shadow": "6px 6px 16px #c7a5a1, -6px -6px 16px rgba(255,255,255,0.2)"
            
        });
        $("#icon").addClass("hide");
        $("#icon-light").removeClass("hide");

    }
    else if(menuPos >= lp && menuPos <= lp + 50)
    {
        $("#openMenu").css({
            "background": "transparent",
            "box-shadow": "6px 6px 16px #BECDE2, -6px -6px 16px rgba(255, 255, 255, 0.5)"
            
        });
        $("#icon-light").addClass("hide");
        $("#icon").removeClass("hide");

    }
    else if(menuPos < wt)
    {
        $("#openMenu").css({
            "background": "#FBFBFB",
            "box-shadow": "6px 6px 16px #BECDE2, -6px -6px 16px rgba(255, 255, 255, 0.5)"
            
        });
        $("#icon-light").addClass("hide");
        $("#icon").removeClass("hide");

    }
    else if(menuPos >= wt && menuPos <= wt + 50)
    {
        $("#openMenu").css({
            "background": "transparent",
            "box-shadow": "6px 6px 16px #456173, -6px -6px 16px rgba(255,255,255,0.1)"
            
        });
        $("#icon").addClass("hide");
        $("#icon-light").removeClass("hide");

    }
    else if(menuPos < ep)
    {
        $("#openMenu").css({
            "background": "#57788D",
            "box-shadow": "6px 6px 16px #456173, -6px -6px 16px rgba(255,255,255,0.1)"
            
        });
        $("#icon").addClass("hide");
        $("#icon-light").removeClass("hide");

    }
    else if(menuPos >= ep && menuPos <= ep + 50)
    {
        $("#openMenu").css({
            "background": "transparent",
            "box-shadow": "6px 6px 16px #BECDE2, -6px -6px 16px rgba(255, 255, 255, 0.5)"
            
        });
        $("#icon-light").addClass("hide");
        $("#icon").removeClass("hide");

    }
//     else if(menuPos < fq)
//     {
//         $("#openMenu").css({
//             "background": "#FBFBFB",
//             "box-shadow": "6px 6px 16px #BECDE2, -6px -6px 16px rgba(255, 255, 255, 0.5)"
            
//         });
//         $("#icon-light").addClass("hide");
//         $("#icon").removeClass("hide");
//     }
//     else if(menuPos >= fq && menuPos <= fq + 40)
//     {
//         $("#openMenu").css({
//             "background": "transparent",
//             "box-shadow": "6px 6px 16px #BECDE2, -6px -6px 16px rgba(255, 255, 255, 0.5)"
            
//         });
//     }
    else if(menuPos < ns)
    {
        $("#openMenu").css({
            "background": "#E9F1FA",
            "box-shadow": "6px 6px 16px #BECDE2, -6px -6px 16px rgba(255, 255, 255, 0.5)"
        });
        $("#icon-light").addClass("hide");
        $("#icon").removeClass("hide");
    }
    else if(menuPos >= ns && menuPos <= ns + 40)
    {
        $("#openMenu").css({
            "background": "transparent",
            "box-shadow": "6px 6px 16px #BECDE2, -6px -6px 16px rgba(255, 255, 255, 0.5)"
            
        });
    }
    else{
        $("#openMenu").css({
            "background": "#E9F1FA",
            "box-shadow": "6px 6px 16px #BECDE2, -6px -6px 16px rgba(255, 255, 255, 0.5)"
            
        });
    }
  }
}

changeMenuIconColor();
// setWheeler();

var rotation = 0;
var scrollLoc = $(document).scrollTop();
var line = $(".line");



$(window).scroll(function(){

        var newloc = $(document).scrollTop();
        var diff = scrollLoc - newloc;
        rotation -= diff/5, scrollLoc =newloc;
        var rotationStr = "rotate("+ rotation +"deg)";
        $(".fixed-svg").css({
            "-webkit-transform": rotationStr,
            "-moz-transform": rotationStr,
            "transform": rotationStr
        });

//         if(newloc > 10){
//             $(".lng-btn").addClass("hide");
//         }
//         else{
//             $(".lng-btn").removeClass("hide");
//         }


//         lineNav();

        changeMenuIconColor();
        // setWheeler();
    });



  
    $('#showpyd1').click(function(){
        // $('#pyd1').addClass("show")
        $('#btnwrap1').toggleClass("hide");
   
        $('#pyd1').slideDown(function(){
           $('#pyd1').toggleClass("show");
        }
        );

    });
    $('#hidepyd1').click(function(){
        // $('#pyd1').removeClass("s")
        $('#pyd1').slideUp(function(){
            $('#pyd1').toggleClass("show");
            $('#btnwrap1').toggleClass("hide");
        });

    });


    $('#showpyd2').click(function(){
        // $('#pyd1').addClass("show")
        $('#btnwrap2').toggleClass("hide");
   
        $('#pyd2').slideDown(function(){
           $('#pyd2').toggleClass("show");
        }
        );

    });
    $('#hidepyd2').click(function(){
        // $('#pyd1').removeClass("s")
        $('#pyd2').slideUp(function(){
            $('#pyd2').toggleClass("show");
            $('#btnwrap2').toggleClass("hide");
        });

    });
    $('#showpyd3').click(function(){
        // $('#pyd1').addClass("show")
        $('#btnwrap3').toggleClass("hide");
   
        $('#pyd3').slideDown(function(){
           $('#pyd3').toggleClass("show");
        }
        );

    });
    $('#hidepyd3').click(function(){
        // $('#pyd1').removeClass("s")
        $('#pyd3').slideUp(function(){
            $('#pyd3').toggleClass("show");
            $('#btnwrap3').toggleClass("hide");
        });

    });
    $('#showpyd4').click(function(){
        // $('#pyd1').addClass("show")
        $('#btnwrap4').toggleClass("hide");
   
        $('#pyd4').slideDown(function(){
           $('#pyd4').toggleClass("show");
        }
        );

    });
    $('#hidepyd4').click(function(){
        // $('#pyd1').removeClass("s")
        $('#pyd4').slideUp(function(){
            $('#pyd4').toggleClass("show");
            $('#btnwrap4').toggleClass("hide");
        });

    });
    $('#showpyd5').click(function(){
        // $('#pyd1').addClass("show")
        $('#btnwrap5').toggleClass("hide");
   
        $('#pyd5').slideDown(function(){
           $('#pyd5').toggleClass("show");
        }
        );

    });
    $('#hidepyd5').click(function(){
        // $('#pyd1').removeClass("s")
        $('#pyd5').slideUp(function(){
            $('#pyd5').toggleClass("show");
            $('#btnwrap5').toggleClass("hide");
        });

    });
    $('#showpyd6').click(function(){
        // $('#pyd1').addClass("show")
        $('#btnwrap6').toggleClass("hide");
   
        $('#pyd6').slideDown(function(){
           $('#pyd6').toggleClass("show");
        }
        );

    });
    $('#hidepyd6').click(function(){
        // $('#pyd1').removeClass("s")
        $('#pyd6').slideUp(function(){
            $('#pyd6').toggleClass("show");
            $('#btnwrap6').toggleClass("hide");
        });

    });
 
    var swiper = new Swiper('.swiper-container', {
       slidesPerView: 'auto',
      spaceBetween: 10,
//       centeredSlides: true,
      mousewheel:{
          forceToAxis: true,
      },
//       centerInsufficientSlides: true,
//       centeredSlidesBounds: true,
    //   initialSlide: 1,
      grabCursor: true,
        // Disable preloading of all images
  preloadImages: false,
  // Enable lazy loading
  lazy: true,
      watchSlidesVisibility :true,
      lazy: {
//     loadPrevNext: true,
        loadOnTransitionStart:true,
//         loadPrevNextAmount:5,
  },
    
      }
    );

    // swiper.init();
    var swiperts = new Swiper('.swiper-ks-container', {
      slidesPerView: 'auto',
      spaceBetween: 10,
      centeredSlides: true,
      mousewheel:{
          forceToAxis: true,
      },
      centerInsufficientSlides: true,
      centeredSlidesBounds: true,
    //   initialSlide: 1,
      grabCursor: true
    });
 

    // $('.carousel').owlCarousel({
    //     margin:20,
    //     items: 8,
    //     touchDrag: true,
    //     autoWidth:true,
    //     lazyLoad:true,
    //     center: true,
    //     autoHeight: true
    // });
    // $('.tl-carousel').owlCarousel({
    //     items: 5,
    //     touchDrag: true,
    //     autoWidth:true,
    //     autoHeight: true
    // });

  
    